export const mutations = {
  setFeeType: function (state, feetype) {
    state.feetype = feetype;
  },
  replaceSector: function (state, sector) {
    var index = [...state.sector].findIndex(
      (e) => e.ent_sec_code == sector.ent_sec_code
    );
    if (index !== -1) {
      state.sector[index] = sector;
    } else {
      state.sector.push(sector);
    }
  },

  removeSector: function (state, sector) {
    var index = [...state.sector].findIndex(
      (e) => e.ent_sec_code == sector.ent_sec_code
    );
    if (index > -1) {
      state.sector.splice(index, 1);
    }
  },
  setFeeTypeLevel1: function (state, fee_type_level1) {
    state.fee_type_level1 = fee_type_level1;
  },
  setFeeTypeLevel2: function (state, fee_type_level2) {
    state.fee_type_level2 = fee_type_level2;
  },
  setFeeTypeLevel3: function (state, fee_type_level3) {
    state.fee_type_level3 = fee_type_level3;
  },
  setFeeTypeLevel4: function (state, fee_type_level4) {
    state.fee_type_level4 = fee_type_level4;
  },
};
